const areRuntimeMetadataValuesEqual = (currentRuntime = {}, nextRuntime = {}) => {
  if (String(currentRuntime?.kind || '') !== String(nextRuntime?.kind || '')) {
    return false;
  }

  if (String(currentRuntime?.platform || '') !== String(nextRuntime?.platform || '')) {
    return false;
  }

  if (String(currentRuntime?.apiBaseUrl || '') !== String(nextRuntime?.apiBaseUrl || '')) {
    return false;
  }

  return JSON.stringify(currentRuntime?.surface || {}) === JSON.stringify(nextRuntime?.surface || {});
};

export default areRuntimeMetadataValuesEqual;
